(function( global, $, Handlebars, EventData, moment ) { // eslint-disable-line
    var pluginName = 'Tooltip';

    // Constructor
    function Tooltip() {
        this.body = document.querySelector('body');
        this.container = document.querySelector('.tooltip-container');
        this.source = document.querySelector('[pc-tooltip-template]');
        this.element = null;
        this.tooltip = null;
        this.tooltipClose = null;
        this.data = {};
        this.state = 'closed';
        this.init(); // create container for tooltips
    }

    Tooltip.prototype.init = function init() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'tooltip-container';
            this.body.appendChild(this.container);
        }
    };

    /**
     * Build tooltip
     *
     * @param {object} event
     * @param {object} element
     * @param {object} jsEvent
     */
    Tooltip.prototype.render = function render(event, element, jsEvent) {
        if (!this.source) {
            console.warn('Tooltip template source not found');
            return;
        }

        this.clear();
        this.element = element;
        var spaceX = window.innerWidth - jsEvent.pageX;
        var tooltipWidth = 400;
        var noSpaceRight = spaceX < tooltipWidth ? true : false;
        this.data = EventData(event);
        global.methods.objectAssign(this.data, {
            jsEvent: {
                posX: jsEvent.pageX,
                posY: jsEvent.pageY
            }
        });

        //Quirky fix, needs refactoring
        var self = this;
        setTimeout(function() { self.state = 'opened'} , 500);

        // Build with handlebars.js
        var source = $(this.source).html();
        var template = Handlebars.compile(source);
        var $tooltipContainer = $(this.container);

        $tooltipContainer.html(template(this.data));
        this.tooltip = this.container.querySelector('[pc-tooltip]');
        this.tooltipClose = this.container.querySelector('[pc-tooltip-close]');
        noSpaceRight ? this.tooltip.classList.add('pc-tooltip--no-space-right') : '';
        this.tooltipClose.addEventListener('click', this.clear.bind(this));
        document.addEventListener('click', this.handleDocumentClick.bind(this));

        var eventRepresentationId = event.data.booking.id+'-'+moment(event.start).toISOString();

        $tooltipContainer.find('[data-async-details]').remove();

        $.App.api('GET', 'bookings/'+event.data.booking.id+'/representation-stats-sets')
            .done(function (response) {
                var collection = response.collection,
                    representationStatsSet = null;

                $.each(collection, function () {
                    var representationId = this.booking.id+'-'+moment(this.representation_date).toISOString();

                    if (representationId === eventRepresentationId) {
                        representationStatsSet = this;

                        return false;
                    }
                });

                if (representationStatsSet) {
                    var soldOverall = representationStatsSet.sold_overall,
                        saleTickets = representationStatsSet.sale_tickets,
                        soldPercent = Math.round(representationStatsSet.sold_percent);
                        blockedOverall = representationStatsSet.blocked_overall;

                    $tooltipContainer.find('.pc-tooltip__body').append([
                        '<ul class="pc-tooltip__details" data-async-details>',
                            '<li class="pc-tooltip__report u-margin-top-xs u-margin-bottom-xs">',
                                '<strong>Billets vendus:</strong>',
                                '<span>'+soldOverall+'/'+saleTickets+' ('+soldPercent+'%)</span>',
                                blockedOverall > 0 ? '<span class="u-font-weight-600 u-font-size-lg u-color-secondary"> — Blocage</span>' : '',
                            '</li>',
                        '</ul>'
                    ].join(''));
                }
            })
            .fail(function () {
                window.location.reload();
            });
    };

    Tooltip.prototype.handleDocumentClick = function handleDocumentClick(event) {

        if (!this.element[0].contains(event.target) && !this.tooltip.contains(event.target) && this.state == 'opened') {
            console.log(this.state);
            this.clear();
        }
    };

    Tooltip.prototype.clear = function clear() {
        document.removeEventListener('click', this.handleDocumentClick);
        while (this.container.firstChild) {
            this.container.removeChild(this.container.firstChild);
        }

        //Quirky fix, needs refactoring
        var self = this;
        setTimeout(function() { self.state = 'closed'} , 500);
    };

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports)
        module.exports = Tooltip; // Export to Browser
    else
        global[pluginName] = Tooltip; // eslint-disable-line

}( window.groots, jQuery, require('handlebars'), require('./_eventdata.js'), require('moment') ));
